module.exports = __webpack_public_path__ + "static/media/past_3.82b99084.jpg";